import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  Components.addType("filterCard", {
    model: {
      defaults: {
        components: ``,
      },
    },
  });
};
